export enum AlertType {
  Info = 'alert-info',
  Success = 'alert-success',
  Warning = 'alert-warning',
  Error = 'alert-error',
  Undefined = ''
}

export abstract class BaseAlertDataObject {
  readonly type: AlertType;
  showAlert: boolean;
  uid: string;

  title?: string;
  text?: string;
  params?: any;
  private static readonly ALERT_ARIA_LABELS: Record<AlertType, string> = {
    [AlertType.Info]: 'Beskedbox der viser information',
    [AlertType.Success]: 'Beskedbox der viser succes',
    [AlertType.Warning]: 'Beskedbox der viser en advarsel',
    [AlertType.Error]: 'Beskedbox der viser en fejlmeddelelse',
    [AlertType.Undefined]: ''
  };

  constructor(
    uid: string,
    type: AlertType,
    title?: string,
    text?: string,
    params?: any
  ) {
    this.type = type;
    this.title = title;
    this.text = text;
    this.params = params;
    this.showAlert = true;
    this.uid = uid;
  }

  public get class(): string {
    return `${this.type}`;
  }

  public get ariaLabel(): string {
    return this.getAlertAriaLabel(this.type);
  }

  public get getAlertType(): AlertType {
    return this.type;
  }

  public getShowAlert(): boolean {
    return this.showAlert;
  }

  public getUid(): string {
    return this.uid;
  }

  getAlertAriaLabel(type: AlertType): string {
    return BaseAlertDataObject.ALERT_ARIA_LABELS[type];
  }
}

export class CustomAlert extends BaseAlertDataObject {
  constructor(uid: string, title: string, text: string, params?: any) {
    super(uid, AlertType.Info, title, text, params);
  }
}

export class InfoAlert extends BaseAlertDataObject {
  constructor(uid: string, title: string, text: string, params?: any) {
    super(uid, AlertType.Info, title, text, params);
  }
}

export class SuccessAlert extends BaseAlertDataObject {
  constructor(uid: string, title: string, text: string, params?: any) {
    super(uid, AlertType.Success, title, text, params);
  }
}

export class WarningAlert extends BaseAlertDataObject {
  constructor(uid: string, title: string, text: string, params?: any) {
    super(uid, AlertType.Warning, title, text, params);
  }
}

export class ErrorAlert extends BaseAlertDataObject {
  constructor(uid: string, title: string, text: string, params?: any) {
    super(uid, AlertType.Error, title, text, params);
  }
}
